import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {map} from "rxjs/operators";

@Injectable()
export class AgentsService {
  private BASE_URL = 'oc-api/operations/api-users'

  constructor(private http: HttpClient) {
  }

  createAgent(agentName: string, agentTypeId = '3'): Observable<any> {
    return this.http.post(`${this.BASE_URL}/create-agent/`, {agentName, agentTypeId});
  }

  getAgents(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/agents`).pipe(map(res => <any>res));
  }
}



// WEBPACK FOOTER //
// ./src/app/agents/agents.service.ts